import React, { memo } from 'react';
import { CheckCircle2, Brain, Heart, Smile } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function SolutionSection() {
  return <section className="bg-white py-20 px-4 relative overflow-hidden" data-id="element-279">
      {/* Decorative Blobs */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-yellow-100 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob" data-id="element-280"></div>
      <div className="absolute top-0 left-0 w-64 h-64 bg-blue-100 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob animation-delay-2000" data-id="element-281"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-282">
        <div className="text-center mb-16" data-id="element-283">
          <span className="bg-blue-100 text-blue-600 px-4 py-1 rounded-full font-bold tracking-wider uppercase text-sm mb-4 inline-block" data-id="element-284">
            La Solución Divertida
          </span>
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mt-4 mb-6" data-id="element-285">
            Presentamos el{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-red-500" data-id="element-286">
              Mega Pack Anti-Pantallas
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-medium" data-id="element-287">
            La colección más completa de actividades diseñadas para que tus
            hijos aprendan jugando, lejos de la tecnología.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16" data-id="element-288">
          <div className="order-2 md:order-1 space-y-8" data-id="element-289">
            <div className="flex items-start gap-4 bg-white p-4 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-290">
              <div className="bg-green-100 p-4 rounded-2xl" data-id="element-291">
                <Brain className="w-8 h-8 text-green-600" data-id="element-292" />
              </div>
              <div data-id="element-293">
                <h3 className="text-xl font-bold mb-2 text-gray-800" data-id="element-294">
                  Desarrollo Cognitivo
                </h3>
                <p className="text-gray-600" data-id="element-295">
                  Actividades que desafían su mente, mejoran la memoria y
                  fomentan el pensamiento lógico de forma natural.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 bg-white p-4 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-296">
              <div className="bg-pink-100 p-4 rounded-2xl" data-id="element-297">
                <Heart className="w-8 h-8 text-pink-600" data-id="element-298" />
              </div>
              <div data-id="element-299">
                <h3 className="text-xl font-bold mb-2 text-gray-800" data-id="element-300">
                  Conexión Emocional
                </h3>
                <p className="text-gray-600" data-id="element-301">
                  Crea momentos inolvidables en familia, riendo y aprendiendo
                  juntos lejos del aislamiento digital.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 bg-white p-4 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-302">
              <div className="bg-yellow-100 p-4 rounded-2xl" data-id="element-303">
                <Smile className="w-8 h-8 text-yellow-600" data-id="element-304" />
              </div>
              <div data-id="element-305">
                <h3 className="text-xl font-bold mb-2 text-gray-800" data-id="element-306">
                  Diversión Garantizada
                </h3>
                <p className="text-gray-600" data-id="element-307">
                  Juegos tan entretenidos que ni siquiera notarán que están
                  aprendiendo lecciones valiosas.
                </p>
              </div>
            </div>
          </div>

          <div className="order-1 md:order-2 bg-gradient-to-br from-blue-50 to-purple-50 p-8 rounded-[2rem] border-4 border-white shadow-xl relative" data-id="element-308">
            {/* Sticker decoration */}
            <div className="absolute -top-4 -right-4 bg-yellow-400 text-xs font-bold px-3 py-1 rounded-full rotate-12 shadow-sm" data-id="element-309">
              ¡Lo más completo!
            </div>

            <h3 className="text-2xl font-black text-gray-800 mb-6 text-center" data-id="element-310">
              ¿Qué incluye el Pack?
            </h3>
            <ul className="space-y-4" data-id="element-311">
              {['Más de 500 actividades imprimibles', 'Ejercicios de grafomotricidad', 'Laberintos y rompecabezas', 'Actividades de recorte y pegado', 'Dibujos para colorear creativos', 'Juegos de lógica y matemáticas', 'Organizado por niveles de dificultad'].map((item, index) => <li key={index} className="flex items-center gap-3 bg-white p-3 rounded-xl shadow-sm border border-gray-100" data-id="element-312">
                  <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0" fill="#DCFCE7" data-id="element-313" />
                  <span className="font-bold text-gray-700" data-id="element-314">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <CTAButton text="¡QUIERO VER EL PACK COMPLETO!" data-id="element-315" />
      </div>
    </section>;
}